(() => {
  "use strict";

  const loadDeferredStyles = () => {
    const deferredContainer = document.getElementById("deferred-styles");
    
    // Safety check: if the PHP script didn't output the ID, stop here.
    if (!deferredContainer) return;

    // OPTIMIZATION: Use insertAdjacentHTML
    // The old script created a <div>, put the styles inside, and appended the div.
    // This created an ugly structure: <body> ... <div><link href="..."></div> </body>
    // This new method injects the <link> tags directly into the body, no wrapper needed.
    document.body.insertAdjacentHTML('beforeend', deferredContainer.textContent);
    
    // Clean up the DOM by removing the <noscript> tag
    deferredContainer.remove();
  };

  // The "Paint First" Strategy
  // We don't need vendor prefixes (moz, webkit) in 2025.
  // 1. requestAnimationFrame: Waits for the browser to be ready to paint.
  // 2. setTimeout(0): Pushes the heavy lifting to the END of the execution queue.
  // Result: The user sees the critical content (First Paint) BEFORE the browser parses these styles.
  requestAnimationFrame(() => {
    setTimeout(loadDeferredStyles, 0);
  });

})();